import React, { useState,useRef, ReactNode } from "react";

interface TooltipProps {
  children: ReactNode; // The trigger element
  content: ReactNode; // Tooltip content (can be any JSX)
  customStyles?: string;
}

export default function CustomTooltip({ children, content, customStyles }: TooltipProps) {
  const [show, setShow] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setShow(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShow(false);
    }, 300); // 1 second delay
  };

  return (
    <div
      className="relative inline-block w-full"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleMouseEnter}
    >
      {children}

      {show && (
        <div className={`alu-tooltip-box-shadow absolute left-[10%] bottom-[calc(100%+12px)] min-w-[220px] max-w-[220px] px-4 py-2 bg-white rounded-2xl z-[9999] ${customStyles ? customStyles : ''}`}>
          
          <p className="max-h-[140px] overflow-auto custom-scrollbar scrollbar-hide text-sm leading-[21px]">{content}</p>

          {/* Arrow */}
          <div className="absolute left-[20%] -bottom-[6px] w-3 h-3 bg-white border-b border-r border-gray-200 rotate-45"></div>
        </div>
      )}
    </div>
  );
}
